import httpService from "../_utils/http-service";
import { getAuthHttpConfig } from "../_utils/auth-utils";
import { LIMIT } from "../_utils/constants";

import { traceEvent } from "../_utils/analytics-utils";

export const fetchOrders = (customerId, callback) => {
  return function(dispatch, getState) {
    const config = getAuthHttpConfig(getState().storage);

    httpService
      .get(
        `/v2/customers/${customerId}/orders?serviceTypeId=1&limit=${LIMIT}`,
        config
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, orders: res.data.data });
        } else {
          traceEvent("error", "fetchOrders");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "fetchOrders");
        callback({ success: false });
      });
  };
};

export const fetchOrder = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    httpService
      .get(
        `/customers/${customerId}/order/${orderId}`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          traceEvent("error", "fetchOrder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "fetchOrder");
        callback({ success: false });
      });
  };
};

export const emailReceipt = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    traceEvent("order", "email receipt");

    httpService
      .post(
        `/customers/${customerId}/orders/${orderId}/receipt/email`,
        null,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          traceEvent("error", "emailReceipt");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "emailReceipt");
        callback({ success: false });
      });
  };
};
